import styled from 'styled-components'
import tw from 'twin.macro'
import { ColumnCenter } from '../Layout'

export const Wrapper = styled.div`
  ${tw`w-[100%]`}
`

export const ConfirmedIcon = styled(ColumnCenter)`
  ${tw`px-0 py-24`}
`

export const StyledGooeyLoader = styled.div`
  background: ${({ theme }) => theme.colors.darkGray900};
  filter: blur(10px) contrast(20);
  ${tw`w-[100%] h-[100%] relative`}
`

export const Container = styled.div`
  background: ${({ theme }) => `${theme.colors.primary}33`};
  ${tw`flex w-[100%] rounded-6 px-16 py-20`}
`

export const StyledBlobLeft = styled.div`
  background: #defffb;
  transform: translateY(-50%);
  animation: osc-l 2s ease infinite;
  ${tw`w-[40px] h-[40px] absolute rounded-[50%] top-[30%] left-0`}

  @keyframes osc-l {
    0% {
      transform: translateX(30%);
    }
    50% {
      transform: translateX(85%);
    }
    100% {
      transform: translateX(30%);
    }
  }
`

export const StyledBlobRight = styled.div`
  animation: osc-r 2s ease infinite;
  background: #fad4cc;
  transform: translateY(-50%);
  ${tw`w-[40px] h-[40px] absolute rounded-[50%] top-[40%] left-[50%]`}

  @keyframes osc-r {
    0% {
      transform: translateX(60%);
    }
    50% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(60%);
    }
  }
`
